import { render, staticRenderFns } from "./editNew.vue?vue&type=template&id=80b9448a&scoped=true&"
import script from "./editNew.vue?vue&type=script&lang=js&"
export * from "./editNew.vue?vue&type=script&lang=js&"
import style0 from "./editNew.vue?vue&type=style&index=0&id=80b9448a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b9448a",
  null
  
)

export default component.exports